import { ODataSelect } from "@iconics/core";

export class NotificationData extends ODataSelect
{
    public Id = 0;
    public Name = '';
    public EventTypeName?= '';
    public ShouldSendMail = false;
    public ShouldSendMobilePush = false;

    public toSelect(): string
    {
        return '';
    }
}
